import {createLazyFileRoute} from '@tanstack/react-router'

import Business from '@/views/Business/Business'

export const Route = createLazyFileRoute('/business')({
  component: () => <Business />,
})
